import React from "react";
import firebase from "../../constants/Firebase";
import { Link } from "react-router-dom";
import "./browse.css";

class Browse extends React.Component {
	// FETCH FIREBASE
	constructor(props) {
		super(props);
		this.state = {
			users: {},
		};
		this.fetchUsersTabs = this.fetchUsersTabs.bind(this);
	}

	// FOCUS IN MODAL
	componentDidMount() {
		this.fetchUsersTabs();
	}

	// FETCH GET TAB FIREBASE
	async fetchUsersTabs() {
		const requestOptions = {
			method: "GET",
			redirect: "follow",
		};

		await fetch(`${firebase.databaseURL}/users.json`, requestOptions)
			// PARSE JSON HTTP RESPONSE TO TRANSFORM INTO JS OBJECT
			.then((response) => response.json())
			.then((result) => {
				// TAB SET STATE

				this.setState({
					users: result,
					// tabs: result && result.tabs ? result.tabs : {},
				});
			})
			.catch((error) => console.log("error:", error));
	}

	render() {
		const usersTabsArray = Object.keys(this.state.users);
		const users = usersTabsArray.map((userID) => {
			return Object.assign({ userID }, this.state.users[userID]);
		});
		return (
			<main className="main-browse">
				<h2 className="h2-browse">Browse</h2>
				<p className="p-browse">Explore bookmarks pages</p>
				<ul className="browse-list">
					{users.map((item) => {
						return (
							<li className="li-browse">
								<Link
									className="browse-user-link"
									to={`/browse/${item.userID}`}
								>
									{item.userName}
								</Link>
							</li>
						);
					})}
				</ul>
			</main>
		);
	}
}

export default Browse;
